import { IllinoisOperationTaxes } from '../operation-taxes'

export const OperationTaxes = {
  ...IllinoisOperationTaxes,
} as const
